import renderHandlebarsTemplate from "../handlebars/renderHandlebarsTemplate";

export default async function generateCustomXMLFromTemplate({ document }) {
	const { customXmlTemplate } = document.channel;

	return renderHandlebarsTemplate({ template: customXmlTemplate, data: document });
}
